import Vue from "vue";
import { Street } from "./street";

/* global axios */

export class Contratos {
    static create() {
        return {
            radio: {
                ssh: {
                    host: null,
                    username: null,
                    password: null,
                    readyTimeout: 5000,
                    algorithms: {
                        serverHostKey: ["ssh-rsa", "ssh-dss"]
                    }
                }
            },
            concentrador_id: null,
            geocode: {
                latitude: 0,
                longitude: 0
            },
            cliente: {
                nome: null,
                cliente_id: null
            },
            endereco_instalacao: Street.create(),
            bloqueado: false,
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/by-pk/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @returns {Promise}
     */
    static allPositions() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/positions")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byRef(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/by-ref/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    static sync(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("contratos/" + id + "/sync", {})
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param mac
     * @returns {Promise}
     */
    static byMac(mac) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/by-mac/" + mac)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param json
     * @returns {*}
     */
    static updateLoginUsuario(json) {
        return Vue.http.post("contrato/login/usuario", json);
    }

    /**
     *
     * @param json
     * @returns {*}
     */
    static updateObs(json) {
        return Vue.http.put("contrato/obs/info", json);
    }

    /**
     *
     * @param json
     * @returns {*}
     */
    static updateFtth(json) {
        return Vue.http.put("contrato/ftth/update", json);
    }

    /**
     *
     * @return {Promise}
     */
    static countOnlineOffline() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/online-offline")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allNoLatLong() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/no-latlong")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allNoMac() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/no-mac")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allNoIPV6() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/no-ipv6")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static saveObsNoIPV6(obs, id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .put("contratos/no-ipv6", { _id: id, obs: obs })
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static saveOnuMac(onu, id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .put("contratos/" + id + "/mac", { _id: id, onu_mac: onu })
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allNoCaixa() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/no-caixa")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static getBanda() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/relatorio/banda")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static allByCliente(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/clientes/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("contratos", data);
            } else {
                promisse = Vue.http.post("contratos", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static sendComando(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("contrato/comandos/" + data.contrato_id, data)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static sendComandoAll(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("contrato/comandos-all", data)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param status
     * @param minimo
     * @param maximo
     * @returns {Promise<any>}
     */
    static burst(status, minimo, maximo) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("contratos/burst", { burst: status, minimo, maximo })
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static sendPortas(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("contrato/portas/" + data.contrato_id, data)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param contratoId
     * @return {Promise}
     */
    static getPortas(contratoId) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/portas/" + contratoId)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static offlines() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/offline")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static bloqueados() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/bloqueados")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static logs(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/logs/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static boletosCaControl(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get(
                    "https://ca-api.centeralarm.com.br/boletos/by-contrato/" +
                        id
                )
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static checarRecebimento(id) {
        let param = {
            id_contratos_servicos: id
        };
        return new Promise((resolve, reject) => {
            Vue.http
                .post(
                    "https://ca-api.centeralarm.com.br/boletos/buscar-caixa",
                    param
                )
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static liberar5Dias(id) {
        let param = {
            id_contratos_servicos: id
        };

        const instance = axios.create({
            baseURL: "https://ca-api.centeralarm.com.br"
        });

        instance.defaults.headers.common["Authorization"] =
            "JWT " + window.localStorage.getItem("token-ca");

        return instance.put("/contrato/liberar", param);
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static boletosCaControlSMS(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get(
                    "https://ca-api.centeralarm.com.br/boletos/lembrete/sms/" +
                        id
                )
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static boletosCaControlEmail(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("https://ca-api.centeralarm.com.br/boletos/lembrete/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static excluirComandos(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("contrato/comandos/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("contrato/by-pk/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static excluirAll(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("contrato/comandos-all/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static reboot(id) {
        return Vue.http.post("contrato/reboot/" + id);
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static desconectar(id) {
        return Vue.http.post("contrato/desconectar/" + id);
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static bySwitch(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/by-switch/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byPacpon(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/by-pacpon/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byCTO(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/by-cto/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byCTOFtth(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contratos/by-cto/" + id + "/ftth")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @param senha
     * @return {Promise<any>}
     */
    static removeSenhaHotspot(id, senha) {
        return Vue.http.delete("contrato/hotspot/" + id + "/" + senha);
    }

    /**
     *
     * @param id
     * @return {Promise<any>}
     */
    static addSenhaHotspot(id) {
        return Vue.http.post("contrato/hotspot/" + id + "/0");
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static getComandos(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/comandos/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static ping(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("contrato/ping/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }
}
